import type { PageMeta } from "./types";

const pagePrefix = "/p/";

export function pagePath(
  page: Pick<PageMeta, "id" | "title" | "organizationSlug">,
): string {
  const normalized = page.title
    .normalize("NFKD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, "-")
    .replace(/^-|-$/g, "");
  const slug =
    Array.from(normalized).slice(0, 100).join("").replace(/-$/, "") ||
    "untitled";
  // A double hyphen separates the slug from IDs, which can themselves contain hyphens.
  return `${page.organizationSlug ? `/app/${encodeURIComponent(page.organizationSlug)}/p/` : pagePrefix}${encodeURIComponent(slug)}--${encodeURIComponent(page.id)}`;
}

/** Shared route parsing for browser navigation and generated workspace links. */
export function organizationSlug(pathname: string): string | undefined {
  return /^\/app\/([a-z0-9]+(?:-[a-z0-9]+)*)(?:\/|$)/.exec(pathname)?.[1];
}
export function workspaceViewPath(pathname: string): string {
  const slug = organizationSlug(pathname);
  return slug ? pathname.slice(`/app/${slug}`.length) || "/app" : pathname;
}
export function workspacePath(slug: string, view = ""): string {
  return `/app/${encodeURIComponent(slug)}${view && view !== "/app" ? (view.startsWith("/") ? view : `/${view}`) : ""}`;
}
